import { func, number, shape, oneOfType, string } from 'prop-types';
import React from 'react';
import FormBox from '../../components/Form/FormBox';
import PageTitle from '../../components/PageTitle';
import FormHOC from '../../features/HOC/FormHOC';
import InfoBox from '../../components/InfoBox';

function Apartment({
  approvalStatus1,
  approvalStatus2,
  index,
  submitForm,
  currentApplicant,
  ...rest
}) {
  function generateForm() {
    const inputFields = [
      {
        description: 'Ange lägenhetens adress',
        id: 'address',
        placeholder: 'Adress',
        title: 'Adress',
      },
      {
        description: 'Ange lägenhetens postnummer',
        id: 'postalCode',
        placeholder: 'Postnummer',
        title: 'Postnummer',
        validation: 'zip',
      },
      {
        description: 'Ange vilken ort lägenheten ligger i',
        id: 'city',
        placeholder: 'Ort',
        title: 'Ort',
      },
      {
        description: 'Ange lägenhetens objektnummer/kontraktsnummer',
        id: 'objectNumber',
        placeholder: 'Objektnummer/kontraktsnummer',
        title: 'Objektnummer/kontraktsnummer',
      },
      {
        description: 'Ange lägenhetsnumret',
        id: 'apartmentNumber',
        placeholder: 'Lägenhetsnummer',
        title: 'Lägenhetsnummer',
      },
      {
        description: 'Ange antal rum lägenheten har',
        id: 'rooms',
        placeholder: 'Antal rum',
        title: 'Rum',
        type: 'number',
        validation: 'number',
      },
      {
        description: 'Ange hur stor lägenheten är',
        id: 'area',
        placeholder: 'Antal kvm',
        title: 'Yta',
        type: 'number',
        validation: 'number',
      },
      {
        description: 'Ange lägenhetens hyra',
        id: 'rent',
        placeholder: 'Hyra',
        title: 'Hyra',
        type: 'number',
        validation: 'number',
      },
      {
        description: 'Ange datumet du tog över lägenheten',
        id: 'hadSince',
        placeholder: 'Innehaft sedan',
        title: 'Innehaft sedan',
      },
      {
        description: 'Ange vilken hyresvärd som lägenheten tillhör',
        id: 'landlord',
        placeholder: 'Hyresvärd',
        title: 'Hyresvärd',
        validation: 'landlordName',
      },
      {
        description: 'Ange Hyresvärdens adress',
        id: 'landlordAddress',
        placeholder: 'Hyresvärdens adress',
        title: 'Hyresvärdens adress',
      },
      {
        description: 'Ange hyresvärdens telefonnummer',
        id: 'landlordPhone',
        placeholder: 'Hyresvärdens telefonnummer',
        title: 'Hyresvärdens telefonnummer',
        type: 'number',
        validation: 'landlordPhone',
      },
      {
        description: 'Ange hyresvärdens e-post',
        id: 'landlordEmail',
        placeholder: 'Hyresvärdens e-postadress',
        title: 'Hyresvärdens e-post',
        validation: 'landlordEmail',
      },
    ];
    if (currentApplicant.apartments.apartment2) {
      inputFields.push({
        description: 'Ange hur många vuxna som bor i lägenheten idag',
        id: 'adultCount',
        placeholder: 'Antal vuxna',
        title: 'Antal vuxna',
        type: 'number',
        validation: 'number',
      });
      inputFields.push({
        description: 'Ange hur många barn som bor i lägenheten idag',
        id: 'childrenCount',
        placeholder: 'Antal barn',
        title: 'Antal barn',
        type: 'number',
        validation: 'number',
      });
    }
    return inputFields;
  }

  const approvalStatus = index === 1 ? approvalStatus1 : approvalStatus2;

  return (
    <div>
      <PageTitle>Lägenhet #{index}</PageTitle>
      <InfoBox header="Läs detta först">
        <span>
          <strong>OBS:</strong> För att bytet ska kunna genomföras så smidigt
          som möjligt är det viktigt att uppgifterna om Hyresvärden stämmer.
          <br />
          Det är ert ansvar att uppgifterna är korrekta för att ansökan ska nå
          fram ordentligt. Ta därför noggrant reda på vilken adress som ansökan
          ska skickas till, d.v.s Hyresvärdens adress.
          <br />
          <br />
          Lika viktigt är att hyresvärdens e-postadress stämmer.
          <br />
          <strong>
            Observera att din ansökan skickas till denna epost. Är du osäker på
            om du har rätt adress, se till att kontakta din hyresvärd innan du
            fyller i detta fält.
          </strong>
        </span>
      </InfoBox>

      <FormBox
        form={generateForm()}
        handleClick={(e) => submitForm(e, index)}
        status={approvalStatus}
        {...rest}
        currentApplicant={currentApplicant}
      />
    </div>
  );
}

Apartment.propTypes = {
  approvalStatus1: shape({
    type: string,
  }).isRequired,
  approvalStatus2: shape({
    type: string,
  }),
  index: oneOfType([number, string]).isRequired,
  submitForm: func.isRequired,
};

Apartment.defaultProps = {
  approvalStatus2: {
    type: '',
  },
};

export default FormHOC(Apartment, {
  form: 'apartments',
  field: 'apartment',
});



// WEBPACK FOOTER //
// ./src/views/Apartment/index.js